import * as React from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { TopBarButton } from "./TopBarButton"
import { getRoute } from "../helpers/routing"

const LanguageBar = ({ className }) => {
  const {
    i18n: { language },
  } = useTranslation("generic")

  return (
    <div className={className}>
      <TopBarButton
        style={{ textTransform: "uppercase" }}
        to={getRoute("/languages", language)}
      >
        {language}
      </TopBarButton>
    </div>
  )
}

const StyledLanguageBar = styled(LanguageBar)`
  position: absolute;
  right: 0;
`

export default StyledLanguageBar
